var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    _vm.extras &&
    _vm.extras.groupNavbarDisplay &&
    _vm.extras.groupNavbarDisplay.display == 1
  )?_c('div',{staticClass:"pc-header new",style:({
    position:
      _vm.extras && _vm.extras.navbar && _vm.extras.navbar.browse
        ? _vm.extras.navbar.browse
        : '',
  })},[_c('div',{staticClass:"data-body",style:({
      background:
        _vm.extras.navbarBg.colorOrBg == 'color'
          ? _vm.extras.navbarBg.color
          : 'url(' + _vm.extras.navbarBg.src + ')',
    })},[_c('div',{staticClass:"cont-left"},[(_vm.extras.headerLogo.display === 1)?_c('img',{attrs:{"src":_vm.extras.headerLogo.src || _vm.imgUrlObj.logo}}):_vm._e()]),_c('div',{staticClass:"g-menu"},[_c('ul',_vm._l((_vm.titleItem),function(item,index){return _c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.extras.navText['nav' + (index + 2)] == 'show'),expression:"extras.navText['nav' + (index + 2)] == 'show'"}],key:index,class:{
            active: _vm.number === item.key || (_vm.isSetting == 1 && index == 0),
            'cursor-default': _vm.isSetting == 1,
          },style:({
            color:
              _vm.number === item.key
                ? _vm.extras.navbarStyle.navActive == 'custom'
                  ? _vm.extras.navbarStyle.fontColor2
                  : ''
                : _vm.extras.navbarStyle.navDefault == 'custom'
                ? _vm.extras.navbarStyle.fontColor
                : '',
            'font-size':
              _vm.number === item.key
                ? _vm.extras.navbarStyle.navActive == 'custom'
                  ? _vm.extras.navbarStyle.fontSize2 + 'px'
                  : ''
                : _vm.extras.navbarStyle.navDefault == 'custom'
                ? _vm.extras.navbarStyle.fontSize + 'px'
                : '',
            'font-style':
              _vm.number === item.key
                ? _vm.extras.navbarStyle.navActive == 'custom'
                  ? _vm.extras.navbarStyle.fontTilt2 == 'on'
                    ? 'italic'
                    : 'normal'
                  : ''
                : _vm.extras.navbarStyle.navDefault == 'custom'
                ? _vm.extras.navbarStyle.fontTilt == 'on'
                  ? 'italic'
                  : 'normal'
                : '',
            'font-Weight':
              _vm.number === item.key
                ? _vm.extras.navbarStyle.navActive == 'custom'
                  ? _vm.extras.navbarStyle.fontWeight2 == 'on'
                    ? 'bolder'
                    : ''
                  : ''
                : _vm.extras.navbarStyle.navDefault == 'custom'
                ? _vm.extras.navbarStyle.fontWeight == 'on'
                  ? 'bolder'
                  : ''
                : '',
            'padding-right':
              (_vm.extras.navbarStyle.navActive == 'custom' &&
                _vm.extras.navbarStyle.fontTilt2 == 'on') ||
              _vm.extras.navbarStyle.navDefault == 'custom' ||
              _vm.extras.navbarStyle.fontTilt == 'on'
                ? '1px'
                : '',
          }),on:{"click":function($event){_vm.JumpClick(
              item,
              _vm.extras.navText['linkType' + (index + 2)],
              _vm.extras.navText['anchor' + (index + 2)],
              _vm.extras.navText['link' + (index + 2)]
            )}}},[_vm._v(" "+_vm._s(_vm.extras.navText["text" + (index + 2)])+" ")])}),0)]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLangSwitch),expression:"showLangSwitch"}],staticClass:"lang-switch"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentLang),expression:"currentLang"}],staticClass:"lang-select",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.currentLang=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.onLangChange]}},[_c('option',{attrs:{"value":"zh_CN"}},[_vm._v("简体中文")]),_vm._l((_vm.langItems),function(lang){return _c('option',{key:lang.name,domProps:{"value":lang.name}},[_vm._v(" "+_vm._s(lang.displayName)+" ")])})],2)]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLogin && _vm.seminarInfo.isOpenMember != 0),expression:"isLogin && seminarInfo.isOpenMember != 0"}],staticClass:"g-right-new"},[(_vm.memberInfo.headImg)?_c('img',{staticClass:"member-header",attrs:{"src":_vm.memberInfo.headImg},on:{"click":_vm.gotoUserCenter}}):_vm._e(),_c('a',{staticClass:"top-btn member-name",style:({
          color:
            _vm.extras.navbarStyle.navDefault == 'custom'
              ? _vm.extras.navbarStyle.fontColor
              : '',
          'font-size':
            _vm.extras.navbarStyle.navDefault == 'custom'
              ? _vm.extras.navbarStyle.fontSize + 'px'
              : '',
          'font-style':
            _vm.extras.navbarStyle.navDefault == 'custom'
              ? _vm.extras.navbarStyle.fontTilt == 'on'
                ? 'italic'
                : 'normal'
              : '',
          'font-Weight':
            _vm.extras.navbarStyle.navDefault == 'custom'
              ? _vm.extras.navbarStyle.fontWeight == 'on'
                ? 'bolder'
                : ''
              : '',
        }),attrs:{"title":_vm.memberInfo.name},on:{"click":_vm.gotoUserCenter}},[_vm._v(_vm._s(_vm.memberInfo.name))]),_c('a',{staticClass:"top-btn",style:({
          color:
            _vm.extras.navbarStyle.navDefault == 'custom'
              ? _vm.extras.navbarStyle.fontColor
              : '',
          'font-size':
            _vm.extras.navbarStyle.navDefault == 'custom'
              ? _vm.extras.navbarStyle.fontSize + 'px'
              : '',
          'font-style':
            _vm.extras.navbarStyle.navDefault == 'custom'
              ? _vm.extras.navbarStyle.fontTilt == 'on'
                ? 'italic'
                : 'normal'
              : '',
          'font-Weight':
            _vm.extras.navbarStyle.navDefault == 'custom'
              ? _vm.extras.navbarStyle.fontWeight == 'on'
                ? 'bolder'
                : ''
              : '',
        }),on:{"click":_vm.logout}},[_vm._v(_vm._s(_vm.i18n.logout))])]),_c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLogin && _vm.seminarInfo && _vm.seminarInfo.isOpenMember == 1),expression:"!isLogin && seminarInfo && seminarInfo.isOpenMember == 1"}],staticClass:"g-right-new"},[_c('a',{staticClass:"top-btn",class:{
            'cursor-default': _vm.isSetting == 1,
          },style:({
            'border-color': _vm.extras.login.lineStyle,
            color:
              _vm.extras.navbarStyle.navDefault == 'custom'
                ? _vm.extras.navbarStyle.fontColor
                : '',
            'font-size':
              _vm.extras.navbarStyle.navDefault == 'custom'
                ? _vm.extras.navbarStyle.fontSize + 'px'
                : '',
            'font-style':
              _vm.extras.navbarStyle.navDefault == 'custom'
                ? _vm.extras.navbarStyle.fontTilt == 'on'
                  ? 'italic'
                  : 'normal'
                : '',
            'font-Weight':
              _vm.extras.navbarStyle.navDefault == 'custom'
                ? _vm.extras.navbarStyle.fontWeight == 'on'
                  ? 'bolder'
                  : ''
                : '',
          }),on:{"click":function($event){return _vm.goto('login')}}},[_vm._v(_vm._s(_vm.i18n.login))]),_c('a',{staticClass:"top-btn",class:{
            'cursor-default': _vm.isSetting == 1,
          },style:({
            'border-color': _vm.extras.login.lineStyle,
            color:
              _vm.extras.navbarStyle.navDefault == 'custom'
                ? _vm.extras.navbarStyle.fontColor
                : '',
            'font-size':
              _vm.extras.navbarStyle.navDefault == 'custom'
                ? _vm.extras.navbarStyle.fontSize + 'px'
                : '',
            'font-style':
              _vm.extras.navbarStyle.navDefault == 'custom'
                ? _vm.extras.navbarStyle.fontTilt == 'on'
                  ? 'italic'
                  : 'normal'
                : '',
            'font-Weight':
              _vm.extras.navbarStyle.navDefault == 'custom'
                ? _vm.extras.navbarStyle.fontWeight == 'on'
                  ? 'bolder'
                  : ''
                : '',
          }),on:{"click":function($event){return _vm.goto('register')}}},[_vm._v(_vm._s(_vm.i18n.register))])])])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }